import React from 'react';
import Hero from './Hero';
import EstatesSection from './EstatesSection';
import WhyInvest from './WhyInvest';
import LeadForm from './LeadForm';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <EstatesSection />
      <WhyInvest />
      <LeadForm />
      <Footer />
    </div>
  );
};

export default LandingPage;

